// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__g_HdP","colMin":"styles_colMin__2jgZu"};